import PhoneInput from "react-phone-number-input"
import { CustomBirthDateInput } from "../../../components/Inputs"
import { useDispatch } from "react-redux"
import { BoxAlert } from "../../../components/Alerts"
import { personalInputs } from "../../../data/inputs"
import { Link, useNavigate } from 'react-router-dom'
import { lookupPhone } from "../../../libs/twilio";

const FormAfterValidation = ({ data: { formik, twilioError, setTwilioError, registrarUsuario, resetDocument } }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handlePhone = (value) => formik.setFieldValue("phone", value)
  const handleBirthDate = (value) => formik.setFieldValue("birthDate", value || "")

  const onSubmit = async () => {
  const errors = await formik.validateForm()

  if (Object.keys(errors).length > 0) {
    // Hay errores => no seguimos
    formik.setTouched(
      Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {}),
      true
    )
    return
  }

  dispatch({ type: 'SET_IS_LOADING', payload: true })

  const output = await lookupPhone(formik.values.phone)
  if (!output?.mobile) {
    setTwilioError('Ingresá un número celular válido')
    dispatch({ type: 'SET_IS_LOADING', payload: false })
    return
  }

  const defaultValues = {
    idType: formik.values.idType || '',
    idNumber: formik.values.idNumber || '',
    name: formik.values.name || '',
    surname: formik.values.surname || '',
    receiveEmail: false,
    comments: '',
    birthDate: formik.values.birthDate || '',
    gender: formik.values.gender || '',
    phone: formik.values.phone || '',
    mail: formik.values.mail || '',
    role: 'USER_ROL_STANDARD',
    mn: '',
    mp: '',
    oldUser: false,
    registeredDate: null,
    specialty: '',
    streetName: '',
    streetNumber: '',
    city: '',
    streetDescription: '',
  }

  try {
    await registrarUsuario(defaultValues)
    setTimeout(() => dispatch({ type: 'SET_IS_LOADING', payload: false }), 2000)
    navigate('/login')
  } catch (err) {
    console.error('Error al registrar:', err)
    dispatch({ type: 'SET_IS_LOADING', payload: false })
  }
}


  return (
    <>
       <BoxAlert data={{ type: "info", extraContainerStyles: "sm:col-span-2" }}>
        <p>
          Si querés continuar con otro documento hacé{" "}
          <span
            onClick={resetDocument}
            className="!text-blue-900 !underline !cursor-pointer"
          >
            clic aquí
          </span>.
        </p>
      </BoxAlert>
    <form className='pt-6'>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-6 pb-4'>
        {personalInputs.map((input, i) => (
          <div key={i} className={input.span}>
            {input.options.length < 1
              ? input.name === "birthDate"
                ? <CustomBirthDateInput data={{ input, formik, handleBirthDate }} />
                : (
                  <fieldset className="flex flex-col gap-1">
                    <span className='text-xs opacity-70'>{input.title}</span>
                    <input
                      className='pb-1 outline-none bg-transparent text-darkBlue placeholder:text-[#16325C99] min-h-[24px]'
                      type={input.type}
                      placeholder={input.placeholder}
                      name={input.name}
                      onChange={formik.handleChange}
                      value={formik.values[input.name]}
                    />
                    <div className={`text-xs text-red-400 border-t pt-1 ${formik.errors[input.name] ? 'border-error' : ''}`}>
                      {formik.errors[input.name]}
                    </div>
                  </fieldset>
                )
              : (
                <fieldset className="flex flex-col gap-1">
                  <span className='text-xs opacity-70'>{input.title}</span>
                  <select
                    name={input.name}
                    onChange={formik.handleChange}
                    value={formik.values[input.name]}
                    className="pb-1 outline-none text-darkBlue"
                  >
                    <option value="">Seleccionar</option>
                    {input.options.map((o, i) => <option key={i} value={o.value}>{o.label}</option>)}
                  </select>
                  <div className={`text-xs text-red-400 border-t pt-1 ${formik.errors[input.name] ? 'border-error' : ''}`}>
                    {formik.errors[input.name]}
                  </div>
                </fieldset>
              )}
          </div>
        ))}

        <fieldset className="h-20 flex flex-col gap-1">
          <span className='text-xs opacity-70'>Número celular</span>
          <PhoneInput
            international
            defaultCountry="AR"
            onChange={handlePhone}
            value={formik.values["phone"]}
            placeholder="Cód. de área + Núm. Celular"
            numberInputProps={{
              style: {
                boxShadow: "none",
                border: "none",
                outline: "none",
                background: "transparent",
                marginLeft: "-25px"
              },
            }}
          />
          <span className={`text-xs opacity-60 border-t pt-1 ${formik.errors["phone"] ? 'border-error' : ''}`}>
            Sin el 0 y sin el 15
          </span>
          <div className={`text-xs text-red-400`}>
            {formik.errors["phone"] || twilioError}
          </div>
        </fieldset>
      </div>

      <div className='w-full flex md:justify-between gap-4 pb-5 md:pb-10 pt-4'>
        <Link
          to="/agenda/"
          className='w-full lg:max-w-max border border-cyan text-cyan py-4 px-6 400:px-12 rounded-lg flex-1 opacity-70 text-center'
        >
          Volver
        </Link>
        <button
          type="button"
          onClick={onSubmit}
          className='w-full lg:max-w-max text-white bg-cyan shadow-6 py-4 px-6 400:px-12 rounded-lg flex-1'
        >
          Continuar
        </button>
      </div>
    </form>
    </>
  )
}

export default FormAfterValidation
